// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__355K9","footer":"ReportModalFilter_footer__3rCZS"};